import { API, serializeParams } from "../../utils";

export const getActivityLogListApi = async (params) => {
  const res = await API.get("activity-logs", {
    params,
    paramsSerializer: serializeParams,
  });
  return res.data;
};

export const getActivityLogDetailsApi = async (activityLogId) => {
  const response = await API.get(`activity-logs/${activityLogId}`);
  return response.data;
};

export const getAppSettingsApi = async () => {
  const response = await API.get(`app-settings`);
  return response.data;
}

export const getFeaturesApi = async () => {
  const response = await API.get(`features`);
  return response.data;
};